<template lang="html">
	<div>
	  <!-- Selection Actions Bar -->
	  <div v-if="totalSelectedCount > 0" class="flex justify-end items-center mb-3 p-3 bg-gray-100 rounded">
		<span class="mr-4 text-gray-700">
		  <strong>{{ totalSelectedCount }}</strong> ligne(s) sélectionnée(s)
		</span>
		<vs-button 
		  color="primary" 
		  type="filled"
		  icon-pack="feather"
		  icon="i-activity"
		  @click="analyzeSelected">
		  Ajouter / Créer une liste
		</vs-button>
	  </div>

	  <vs-table
		:data="backlinkList"
		:not-expand="true"
		v-model="selected"
		multiple>
	
		<template slot="thead">
		  <vs-th v-for="(col, indexcol) in $props.columns" :sort-key="col.key" style="pointer-events: auto;">
			{{col.title}}
		  </vs-th>

		</template>
		<template slot-scope="{data}">
	<vs-tr
		:data="tr"
		:key="indextr"
		v-for="(tr, indextr) in data"
		id="backlink-up-row"
	>
		<vs-td :data="tr.name">
			<a target="_blank" :href="`https://${tr.name}`">{{ tr.name }} </a>
		</vs-td>
		<vs-td :data="tr.hosting_country">
			{{ tr.hosting_country || "-" }}
		</vs-td>
		<vs-td :data="tr.articles_price" style="text-align: right">
			{{
				tr.articles_price
					? formatNumberWithSpaces(tr.articles_price) + " €"
					: "-"
			}}
		</vs-td>
		<vs-td :data="tr.articles_price_1" style="text-align: right">
			{{
				tr.articles_price_1
					? formatNumberWithSpaces(tr.articles_price_1) + " €"
					: "-"
			}}
		</vs-td>
		<vs-td :data="tr.traffic" style="text-align: right; min-width: 100px">
			{{ formatNumberWithSpaces(tr.traffic) }}
		</vs-td>
		<vs-td :data="tr.tf" style="text-align: right">
			{{ tr.tf || "-" }}
		</vs-td>
		<vs-td :data="tr.cf" style="text-align: right">
			{{ tr.cf || "-" }}
		</vs-td>
		<vs-td :data="tr.domain_ref" style="text-align: right">
			{{ formatNumberWithSpaces(tr.domain_ref) }}
		</vs-td>
		<vs-td :data="tr.keywords" style="text-align: right">
			{{ formatNumberWithSpaces(tr.keywords) }}
		</vs-td>
		<vs-td :data="Number(tr.bqs_score) || 0" style="text-align: center">
			<vs-chip
				v-if="tr.bqs_score !== null && tr.bqs_score !== undefined"
				:color="getBqsColor(tr.bqs_score)"
				style="font-size: 12px"
			>
				&nbsp;&nbsp;{{ Math.round(Number(tr.bqs_score)) }}&nbsp;&nbsp;
			</vs-chip>
			<span v-else>-</span>
		</vs-td>
		<vs-td :data="tr.category">
			<div v-if="tr.category" class="category-chips">
				<vs-chip
					v-for="(cat, catIndex) in getCategoryArray(tr.category)"
					:key="catIndex"
					color="primary"
					style="margin: 2px; font-size: 11px"
				>
					{{ cat.trim() }}
				</vs-chip>
			</div>
			<span v-else>-</span>
		</vs-td>

		<!-- <template class="expand-user" slot="expand">
			<div class="con-expand-users w-full">
				<vs-table :data="$props.dataList" class="w-full">
					<template slot="thead">
						<vs-th> Source </vs-th>
						<vs-th v-for="(cols, indexcol) in $props.subColPaperClub">
							{{ cols.title }}
						</vs-th>
					</template>
					<template slot-scope="{ data }">
						<vs-tr :data="tr" :key="indextr" class="w-full">
							<vs-td id="backlink-down-row">
								<b>Paperclub</b>
							</vs-td>
							<vs-td
								:data="tr[subCol.key]"
								v-for="(subCol, indexSub) in $props.subColPaperClub"
								id="backlink-down-row"
							>
								{{
									([3, 4].includes(indexSub)
										? formatNumberWithSpaces(tr[subCol.key])
										: tr[subCol.key] || "-") +
									(subCol.title == "PRIX" ? " €" : "")
								}}
							</vs-td>
						</vs-tr>
						<vs-tr :data="tr" :key="indextr" class="w-full">
							<vs-td id="backlink-down-row">
								<b>Rocketlinks</b>
							</vs-td>
							<vs-td
								:data="tr[subCol.key]"
								v-for="(subCol, indexSub) in $props.subColRocketlinks"
								id="backlink-down-row"
							>
								{{
									([3, 4].includes(indexSub)
										? formatNumberWithSpaces(tr[subCol.key])
										: tr[subCol.key] || "-") +
									(subCol.title == "PRIX" ? " €" : "")
								}}
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</template> -->
	</vs-tr>
</template>
	  </vs-table>
	  
	  <!-- Backlinks List Selection Popup -->
	  <BacklinksListSelectionPopup
		v-if="showListSelectionPopup"
		:popup-active="showListSelectionPopup"
		:selected-backlinks="getBacklinksSelectedIds"
		@close="showListSelectionPopup = false"
		@success="handleListSelectionSuccess"
	  />
	</div>
  </template>

<script>
import utilsMixin from "@/mixins/utilsMixin";
import { mapGetters, mapMutations } from "vuex";
import DescColorChipRenderer from "../views/dashboard/prospection/cellRenderer/DescColorChipRenderer.vue";
import BacklinksListSelectionPopup from "../popups/BacklinksListSelectionPopup.vue";

export default {
	props: {
		columns: Array,
		subColPaperClub: Array,
		subColRocketlinks: Array,
		dataList: Array,

		// services: Array,
	},
	mixins: [utilsMixin],
	components: {
		DescColorChipRenderer,
		BacklinksListSelectionPopup,
	},
	data() {
		return {
			backlinkList: this.$props.dataList,
			backlinkTableKey: 0,
			selected: [],
			showListSelectionPopup: false,
		};
	},
	created() {
		// this.backlinkList = this.$props.dataList;
	},
	watch: {
		selected: {
			deep: true,
			handler(newVal, oldVal) {
				if (!oldVal) oldVal = [];

				// Update store based on current selection changes
				// Remove deselected items
				oldVal.forEach((item) => {
					if (!newVal.find((newItem) => newItem.id === item.id)) {
						this.$store.commit("REMOVE_BACKLINK_SELECTION", item.id);
					}
				});
				// Add newly selected items
				newVal.forEach((item) => {
					this.$store.commit("ADD_BACKLINK_SELECTION", item.id);
				});
				// Update current page selection in store
				this.$store.commit("SET_BACKLINKS_CURRENT_PAGE_SELECTED", newVal);
			},
		},
		dataList: {
			immediate: true,
			handler(newVal) {
				this.backlinkList = newVal;
				// Use nextTick to ensure the table has updated before restoring selection
				this.$nextTick(() => {
					// Restore selection for items that are in the new page
					const itemsToSelect = this.backlinkList.filter((item) =>
						this.isBacklinkSelected(item.id)
					);
					if (itemsToSelect.length > 0) {
						this.selected = itemsToSelect;
					}
				});
			},
		},
	},
	computed: {
		...mapGetters([
			"getBacklinksSelectedIds",
			"getBacklinksSelectedCount",
			"isBacklinkSelected",
		]),
		// Get total count of selected items across all pages
		totalSelectedCount() {
			return this.getBacklinksSelectedCount;
		},
		// Get all selected items data (for display/debugging)
		allSelectedItems() {
			return this.getBacklinksSelectedIds;
		},
	},
	methods: {
		...mapMutations([
			"ADD_BACKLINK_SELECTION",
			"REMOVE_BACKLINK_SELECTION",
			"SET_BACKLINKS_CURRENT_PAGE_SELECTED",
			"CLEAR_ALL_BACKLINKS_SELECTIONS",
		]),
		// Get color for BQS score chip
		getBqsColor(score) {
			const value = 101 - Number(score);
			if (value === 0 || isNaN(value)) return "#C3C3C3";
			return this.gradientColor(value);
		},
		// Split categories string into array
		getCategoryArray(categoryString) {
			if (!categoryString) return [];
			return categoryString.split(",").filter((cat) => cat && cat.trim());
		},
		// Store current selections before pagination
		storeSelections() {
			// Add current page selections to the store
			this.selected.forEach((item) => {
				this.ADD_BACKLINK_SELECTION(item.id);
			});
		},
		// Restore selections after pagination
		restoreSelections() {
			const restoredItems = [];
			this.backlinkList.forEach((item) => {
				if (this.isBacklinkSelected(item.id)) {
					restoredItems.push(item);
				}
			});
			// Force update the selected array
			this.selected = restoredItems;
		},
		// Clear all selections across all pages
		clearAllSelections() {
			this.CLEAR_ALL_BACKLINKS_SELECTIONS();
			this.selected = [];
		},
		// Select all items on current page
		selectAllCurrentPage() {
			this.selected = [...this.backlinkList];
		},
		// Analyze selected items
		analyzeSelected() {
			const selectedIds = this.getBacklinksSelectedIds;

			if (selectedIds.length === 0) {
				this.$vs.notify({
					title: "Attention",
					text: "Veuillez sélectionner au moins un backlink",
					color: "warning",
					position: "top-right",
				});
				return;
			}

			// Show the list selection popup
			this.showListSelectionPopup = true;
		},

		handleListSelectionSuccess(data) {
			console.log("List selection success:", data);

			// Clear selections after successful addition
			this.clearAllSelections();

			// Emit event to parent component if needed
			this.$emit("analyze-complete", data);
		},
		async tets(tr) {
			//console.log("message");
		},
		async addSave(tr) {
			let url = "";
			if (tr.is_save) url = "backlinks/unsave";
			else url = "backlinks/save";
			await this.$http.post(url, { link: tr.name });
			tr.is_save = !tr.is_save;
		},
		async addShortlist(tr) {
			let url = "";
			if (tr.is_shortlist) url = "backlinks/unshortlist";
			else url = "backlinks/shortlist";
			await this.$http.post(url, { link: tr.name });
			tr.is_shortlist = !tr.is_shortlist;
		},
	},
};
</script>

<style scoped>
.category-chips {
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	align-items: center;
}
</style>
